import { useFormContext } from 'react-hook-form';

import { TCompanyDetailsDataDE } from '../CompanyDetailsDE';
import CompanyInputManualDE from './CompanyInputManualDE/CompanyInputManualDE';
import CompanyInputSearchDE from './CompanyInputSearchDE/CompanyInputSearchDE';

export const CompanyInputDE = () => {
  const { setValue, watch } = useFormContext<TCompanyDetailsDataDE>();

  const isManualInput = watch('isManualInput');

  const setManualInput = (newIsManualInput: boolean) =>
    setValue('isManualInput', newIsManualInput);

  if (isManualInput) {
    return (
      <CompanyInputManualDE setManualInputFalse={() => setManualInput(false)} />
    );
  }

  return (
    <CompanyInputSearchDE setManualInputTrue={() => setManualInput(true)} />
  );
};
